import { GenIcon } from "../iconBase";

export function GrFormNext(props) {
    return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "polyline", "attr": { "fill": "none", "stroke": "#000", "strokeWidth": "2", "points": "9 6 15 12 9 18" } }] })(props);
};